module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-info"
  }, [_c('div', {
    staticClass: "popup-info__content"
  }, [_c('h3', {
    staticClass: "popup-info__title popup__title"
  }, [_vm._v("\n\t\t\tСПАСИБО, ВАШЕ ВИДЕО"), _c('br'), _vm._v(" ОТПРАВЛЕНО НА МОДЕРАЦИЮ.\n\t\t")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab13f7d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popups/Thank.vue
// module id = 512
// module chunks = 1